
<div class="card card-login" style="width: 130%" *ngIf="socialSignUp">
  <div class="card-content">

    <!--logo section -->
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center" style="width: 50%; margin-left: 28%">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3 class="title hidden">able+</h3>
        </div>
      </div>
    </div>
    <!--logo section end-->

    <!--First step-->
    <div class="col" >
      <div class="input-group col-md-8 col-lg-8 col-sm-8 col-xs-8" style="margin-left: 18%">
        <p style="text-align: center; margin-bottom: 30px; margin-top: 30px">Connect to able+ with one of the following</p>
        <div class="col" >
          <button *ngIf="this.facebook" (click)="onSocialNetworkClick(SocialProviderNameEnum.Facebook)" class="fb btn" style="text-align: left; background-color: #3B5998; color: white; display: block; margin-bottom: 30px; width: 100%">
            <i class="fa fa-facebook fa-fw" style="float:right"></i>Facebook
          </button>
          <button *ngIf="this.linkedin" (click)="onSocialNetworkClick(SocialProviderNameEnum.LinkedIn)" class="linkedin btn" style="text-align: left; background-color: rgb(40,103,178);color: white; display: block; margin-bottom: 30px; width: 100%"><i class="fa fa-linkedin fa-fw" style="float:right">
          </i>LinkedIn
          </button>
          <button *ngIf="this.google" (click)="onSocialNetworkClick(SocialProviderNameEnum.Google)" class="google btn" style="text-align: left;background-color: #dd4b39;color: white; display: block; margin-bottom: 30px; width: 100%"><i class="fa fa-google fa-fw" style="float:right">
          </i>Google
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card card-login" style="width: 130%" *ngIf="linkCheckErrorMessage">
  <div class="card-content">

    <!--logo section -->
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center" style="width: 50%; margin-left: 28%">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3 class="title hidden">able+</h3>
        </div>
      </div>
    </div>
    <!--logo section end-->

    <!--First step-->
    <div class="col" >
      <div class="input-group col-md-8 col-lg-8 col-sm-8 col-xs-8" style="margin-left: 18%">
        <h5 style="text-align: center; margin-bottom: 30px; margin-top: 30px">{{linkCheckErrorMessage}}</h5>
      </div>
    </div>
  </div>
</div>
